// Outline icons (Heroicons/Feather style, 2px stroke, rounded) used by the session UI.
// Every icon takes `size` (px, default 20) and inherits `currentColor`.

const Svg = ({ size = 20, children, strokeWidth = 2, title, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox='0 0 24 24'
    fill='none'
    stroke='currentColor'
    strokeWidth={strokeWidth}
    strokeLinecap='round'
    strokeLinejoin='round'
    aria-hidden={title ? undefined : 'true'}
    role={title ? 'img' : undefined}
    focusable='false'
    {...rest}
  >
    {title && <title>{title}</title>}
    {children}
  </svg>
);

export const MicIcon = ({ off, ...p }) => (
  <Svg {...p}>
    <rect x='9' y='2' width='6' height='12' rx='3' />
    <path d='M5 10v1a7 7 0 0 0 14 0v-1M12 18v4M8 22h8' />
    {off && <path d='M3 3l18 18' />}
  </Svg>
);

export const CameraIcon = ({ off, ...p }) => (
  <Svg {...p}>
    <rect x='2' y='6' width='14' height='12' rx='2' />
    <path d='M16 10l6-3v10l-6-3z' />
    {off && <path d='M2 3l20 18' />}
  </Svg>
);

export const CogIcon = (p) => (
  <Svg {...p}>
    <circle cx='12' cy='12' r='3' />
    <path d='M19.4 15a1.7 1.7 0 0 0 .3 1.8l.1.1a2 2 0 1 1-2.8 2.8l-.1-.1a1.7 1.7 0 0 0-1.8-.3 1.7 1.7 0 0 0-1 1.5V21a2 2 0 1 1-4 0v-.1a1.7 1.7 0 0 0-1.1-1.5 1.7 1.7 0 0 0-1.8.3l-.1.1a2 2 0 1 1-2.8-2.8l.1-.1a1.7 1.7 0 0 0 .3-1.8 1.7 1.7 0 0 0-1.5-1H3a2 2 0 1 1 0-4h.1a1.7 1.7 0 0 0 1.5-1.1 1.7 1.7 0 0 0-.3-1.8l-.1-.1a2 2 0 1 1 2.8-2.8l.1.1a1.7 1.7 0 0 0 1.8.3H9a1.7 1.7 0 0 0 1-1.5V3a2 2 0 1 1 4 0v.1a1.7 1.7 0 0 0 1 1.5 1.7 1.7 0 0 0 1.8-.3l.1-.1a2 2 0 1 1 2.8 2.8l-.1.1a1.7 1.7 0 0 0-.3 1.8V9a1.7 1.7 0 0 0 1.5 1H21a2 2 0 1 1 0 4h-.1a1.7 1.7 0 0 0-1.5 1z' />
  </Svg>
);

export const EyeIcon = (p) => (
  <Svg {...p}>
    <path d='M2 12s3.6-7 10-7 10 7 10 7-3.6 7-10 7S2 12 2 12z' />
    <circle cx='12' cy='12' r='3' />
  </Svg>
);

export const EyeSlashIcon = (p) => (
  <Svg {...p}>
    <path d='M9.9 4.24A9.1 9.1 0 0 1 12 4c6.4 0 10 8 10 8a18.5 18.5 0 0 1-2.16 3.19M6.6 6.6A18.4 18.4 0 0 0 2 12s3.6 8 10 8a9.7 9.7 0 0 0 5.4-1.6' />
    <path d='M9.9 9.9a3 3 0 0 0 4.2 4.2M3 3l18 18' />
  </Svg>
);

export const DocumentIcon = (p) => (
  <Svg {...p}>
    <path d='M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z' />
    <path d='M14 2v6h6M8 13h8M8 17h8M8 9h2' />
  </Svg>
);

export const MenuIcon = (p) => (
  <Svg {...p}>
    <path d='M4 6h16M4 12h16M4 18h16' />
  </Svg>
);

export const CloseIcon = (p) => (
  <Svg {...p}>
    <path d='M18 6L6 18M6 6l12 12' />
  </Svg>
);

export const ArrowRightIcon = (p) => (
  <Svg {...p}>
    <path d='M5 12h14M13 6l6 6-6 6' />
  </Svg>
);

export const TrashIcon = (p) => (
  <Svg {...p}>
    <path d='M3 6h18M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6M10 11v6M14 11v6' />
  </Svg>
);

export const ChevronLeftIcon = (p) => (
  <Svg {...p}>
    <path d='M15 18l-6-6 6-6' />
  </Svg>
);

export const ChevronRightIcon = (p) => (
  <Svg {...p}>
    <path d='M9 18l6-6-6-6' />
  </Svg>
);

export const ChevronDownIcon = (p) => (
  <Svg {...p}>
    <path d='M6 9l6 6 6-6' />
  </Svg>
);

export const ExpandIcon = (p) => (
  <Svg {...p}>
    <path d='M15 3h6v6M9 21H3v-6M21 3l-7 7M3 21l7-7' />
  </Svg>
);

export const CollapseIcon = (p) => (
  <Svg {...p}>
    <path d='M4 14h6v6M20 10h-6V4M14 10l7-7M3 21l7-7' />
  </Svg>
);

export const CheckIcon = (p) => (
  <Svg {...p}>
    <path d='M20 6L9 17l-5-5' />
  </Svg>
);

export const CheckCircleIcon = (p) => (
  <Svg {...p}>
    <circle cx='12' cy='12' r='10' />
    <path d='M8 12l3 3 5-6' />
  </Svg>
);

export const InfoIcon = (p) => (
  <Svg {...p}>
    <circle cx='12' cy='12' r='10' />
    <path d='M12 16v-4M12 8h.01' />
  </Svg>
);

export const AlertIcon = (p) => (
  <Svg {...p}>
    <path d='M10.3 3.9L1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0z' />
    <path d='M12 9v4M12 17h.01' />
  </Svg>
);

export const RefreshIcon = (p) => (
  <Svg {...p}>
    <path d='M21 12a9 9 0 1 1-2.64-6.36L21 8' />
    <path d='M21 3v5h-5' />
  </Svg>
);

export const PlusIcon = (p) => (
  <Svg {...p}>
    <path d='M12 5v14M5 12h14' />
  </Svg>
);

export const PencilIcon = (p) => (
  <Svg {...p}>
    <path d='M12 20h9' />
    <path d='M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4z' />
  </Svg>
);

export const DotsVerticalIcon = (p) => (
  <Svg {...p}>
    <circle cx='12' cy='5' r='1' />
    <circle cx='12' cy='12' r='1' />
    <circle cx='12' cy='19' r='1' />
  </Svg>
);

export const MonitorIcon = (p) => (
  <Svg {...p}>
    <rect x='2' y='3' width='20' height='14' rx='2' />
    <path d='M8 21h8M12 17v4' />
  </Svg>
);

export const PhotoCameraIcon = (p) => (
  <Svg {...p}>
    <path d='M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z' />
    <circle cx='12' cy='13' r='4' />
  </Svg>
);

export const FullscreenIcon = (p) => (
  <Svg {...p}>
    <path d='M8 3H5a2 2 0 0 0-2 2v3M21 8V5a2 2 0 0 0-2-2h-3M3 16v3a2 2 0 0 0 2 2h3M16 21h3a2 2 0 0 0 2-2v-3' />
  </Svg>
);

// Calibration method icons (Figma "Use Card" / "Use Ruler" tiles, 80px).
export const CreditCardIcon = (p) => (
  <Svg {...p}>
    <rect x='2' y='5' width='20' height='14' rx='2' />
    <path d='M2 10h20M6 15h4' />
    <circle cx='15.5' cy='15' r='1.6' />
    <circle cx='18' cy='15' r='1.6' />
  </Svg>
);

export const RulerIcon = (p) => (
  <Svg {...p}>
    <rect x='1.5' y='8' width='21' height='8' rx='1' />
    <path d='M5 8v3M8 8v2M11 8v3M14 8v2M17 8v3M20 8v2' />
  </Svg>
);
